<template>
  <div>
    <!--  面包屑  -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存调拨</el-breadcrumb-item>
    </el-breadcrumb>
    <!--  卡片视图区  -->
    <el-card class="box-card">
      <!--搜索与添加区域-->
      <el-row :gutter="30">
        <el-col :xs="{span:24,offset:0}" :sm="{span:12,offset:0}" :md="{span:12,offset:0}" :lg="{span:6,offset:0}" :xl="{span:6,offset:0}">
          <el-input placeholder="请输入内容" v-model="querInfo.wa_code" clearable @clear="inputchange" @keyup.native.enter="inputchange">
            <el-button slot="append" icon="el-icon-search" @click="inputchange"></el-button>
          </el-input>
        </el-col>
        <el-col :xs="{span:24,offset:0}" :sm="{span:12,offset:0}" :md="{span:12,offset:0}" :lg="{span:6,offset:0}" :xl="{span:6,offset:0}">
          <el-select v-model="querInfo.wa_status" placeholder="请选择是否作废" clearable  @change="selectstatusList">
            <el-option
                v-for="item in statusList"
                :key="item.wa_status"
                :label="item.wa_statusname"
                :value="item.wa_status">
            </el-option>
          </el-select>
        </el-col>
        <el-col :xs="{span:24,offset:0}" :sm="{span:12,offset:0}" :md="{span:12,offset:0}" :lg="{span:6,offset:0}" :xl="{span:6,offset:0}">
          <el-select v-model="querInfo.wa_agent" placeholder="请选择经办人" @change="querInfowecreatorid"
                     clearable class="p_purchase_id">
            <el-option
                v-for="item in userlist"
                :key="item.m_id"
                :label="item.m_name"
                :value="item.m_id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :xs="{span:24,offset:0}" :sm="{span:12,offset:0}" :md="{span:12,offset:0}" :lg="{span:6,offset:0}" :xl="{span:6,offset:0}">
          <el-cascader
              :options="TreeList" v-model="querInfo.warehouselist" placeholder="请选择调入仓库"
              :props="Treeprops" @change="getcheckList"
              clearable></el-cascader>
        </el-col>
        <el-col :xs="{span:24,offset:0}" :sm="{span:12,offset:0}" :md="{span:12,offset:0}" :lg="{span:6,offset:0}" :xl="{span:6,offset:0}">
          <el-cascader
              :options="TreeList" v-model="querInfo.warehouseoutlist" placeholder="请选择调出仓库"
              :props="Treeprops" @change="getcheckoutList"
              clearable></el-cascader>
        </el-col>
        <el-col :xs="{span:24,offset:0}" :sm="{span:12,offset:0}" :md="{span:12,offset:0}" :lg="{span:6,offset:0}" :xl="{span:6,offset:0}">
          <el-date-picker v-model="querInfo.wa_date" class="p_purchase_id" @change="querInfowodate"
                          type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-col>
        <el-col :xs="{span:24,offset:0}" :sm="{span:12,offset:0}" :md="{span:12,offset:0}" :lg="{span:6,offset:0}" :xl="{span:6,offset:0}">
          <el-button type="primary" @click="goAddWarehouseallocation" icon="el-icon-document-add" v-if="is_add">添加</el-button>
          <el-button type="primary" @click="DownloadWarehouseenter" v-if="is_export" icon="el-icon-download">导出</el-button>

        </el-col>
      </el-row>
      <!--   用户列表区域   -->
      <el-table :data="WarehouseallocationList"  border stripe v-loading="loading">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column label="调拨单号" prop="wa_code"></el-table-column>
        <el-table-column label="调拨时间" prop="wa_date"></el-table-column>
        <el-table-column label="经办人" prop="wa_agent_name"></el-table-column>
        <el-table-column label="调出仓库(仓库分区)">
          <template slot-scope="scope">
            <div>{{scope.row.w_out_name}} ({{scope.row.wp_out_name}})</div>
          </template>
        </el-table-column>
        <el-table-column label="调入仓库(仓库分区)">
          <template slot-scope="scope">
            <div>{{scope.row.w_in_name}}({{scope.row.wp_in_name}})</div>
          </template>
        </el-table-column>
        <el-table-column label="是否作废">
          <template slot-scope="scope">
            <i class="el-icon-success" v-if="scope.row.wa_status==1" style="color: lightgreen"></i>
            <i class="el-icon-error" v-else style="color: red"></i>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!--  详情   -->
            <el-tooltip effect="dark" content="详情" placement="top" :enterable="true">
              <el-button type="primary" size="mini" icon="el-icon-tickets"
                         @click="PurchaseWarehousingLi(`${scope.row.wa_id}`)"></el-button>
            </el-tooltip>
            <!--作废-->
            <el-tooltip effect="dark" content="作废" placement="top" :enterable="true" v-if="scope.row.wa_status==1&&is_nullify">
              <el-button type="danger" size="mini" icon="el-icon-document-delete"
                         @click="del(scope.row.wa_id)"></el-button>
            </el-tooltip>


          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="querInfo.page"
          :page-sizes="[3,5,10,15]"
          :page-size="querInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
export default{
  data(){
    return{
      //分页
      querInfo: {
        page: 1,
        limit: 10,
        wa_code:''
      },
      total:0,
      WarehouseallocationList:[],
      WarehouseallocationJurisdiction:[],
      is_add:false,
      is_nullify:false,
      is_export:false,
      is_printing:false,
      loading:true,
      statusList:[{wa_status:0,wa_statusname:'全部'},{wa_status:1,wa_statusname:'正常'},{wa_status:2,wa_statusname:'作废'}],
      userlist:[],
      TreeList:[],
      Treeprops:{
        expandTrigger: 'hover',
        value: 'w_id',
        label: 'w_name',
        children: 'children'},
    }
  },
  created() {
    this.getWarehouseallocationJurisdiction()
    this.getWarehouseallocationList()
    this.showSetTreeList()
    this.getuserList()
  },
  activated(){
    this.getWarehouseallocationList()
    this.showSetTreeList()
    this.getuserList()
  },
  methods:{
    //获取权限接口
    async getWarehouseallocationJurisdiction(){
      this.loading=true
      let str = window.sessionStorage.getItem('activePath');
      let activePath = str.split("/").join("");
      const { data : res } = await this.$http.get('menu/getMenuChildrenList', {params:{m_path : activePath}})
      if (res.code!=200)return  this.$message.error(res.msg)
      this.WarehouseallocationJurisdiction=res.data
      this.WarehouseallocationJurisdiction.forEach((item)=>{
        if (item.m_path=='add'){
          this.is_add=true
        }else if (item.m_path=='nullify'){
          this.is_nullify=true
        }else if (item.m_path=='export'){
          this.is_export=true
        }else if(item.m_path=='printing'){
          this.is_printing=true
        }
      })
    },
    async getWarehouseallocationList(){
      this.loading=true
      const {data: res} = await this.$http.get('warehouseallocation/getList',
          {params: this.querInfo})
      if (res.code !== 200) {
        return this.$message.error(res.msg)
      }
      // 把数据列表 赋值给catelist
      this.WarehouseallocationList = res.data.data
      //把数据赋值给total
      this.total = res.data.total
      this.loading=false
    },
    //获取仓库数据
    async showSetTreeList() {
      //获取所有权限的数据
      const {data: res} = await this.$http.get('warehouse/getTreeList')
      if (res.code != 200) return this.$message.error(res.msg)
      this.TreeList = res.data
    },
    //获取采购员
    async getuserList() {
      const {data: res} = await this.$http.get('member/getMainList')
      if (res.code !== 200) {
        return this.$message.error(res.msg)
      }
      this.userlist=res.data
    },
    //监听pagesize改变
    handleSizeChange(newSize) {
      this.querInfo.limit = newSize
      this.getWarehouseallocationList()
    },
    //监听pagenum 改变
    handleCurrentChange(newPage) {
      this.querInfo.page = newPage
      this.getWarehouseallocationList ()
    },
    querInfowecreatorid(){
      this.querInfo.page=1
      this.getWarehouseallocationList()
    },
    //经办人 查询
    querInfowoagent(){
      this.querInfo.page=1
      this.getWarehouseallocationList()
    },
    //选择时间 查询
    querInfowodate(){
      this.querInfo.page=1
      this.getWarehouseallocationList()
    },
    //选择调入仓库 查询
    getcheckList(){
      this.querInfo.page=1
      this.querInfo.w_in_id=this.querInfo.warehouselist[0]
      this.querInfo.wp_in_id=this.querInfo.warehouselist[1]
      this.getWarehouseallocationList()
    },
    //选择调出仓库 查询
    getcheckoutList(){
      this.querInfo.page=1
      this.querInfo.w_out_id=this.querInfo.warehouseoutlist[0]
      this.querInfo.wp_out_id=this.querInfo.warehouseoutlist[1]
      this.getWarehouseallocationList()
    },
    //选择是否作废
    selectstatusList(){
      this.querInfo.page=1
      this.getWarehouseallocationList()
    },
    inputchange(){
      this.querInfo.page=1
      this.getWarehouseallocationList()
    },
    //添加
    goAddWarehouseallocation(){
      this.$router.push('/warehouseallocation/addwarehouseallocation')
    },
    //详情
    PurchaseWarehousingLi(id){
      this.$router.push({path: "/warehouseallocationDetails", query: {editid: id,is_printing:this.is_printing}})
    },
    //作废
    async del(id){
      const confirmResult = await this.$confirm(
          '此操作将作废该条记录, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消作废')
      }
      const {data:res} = await this.$http.post(`warehouseallocation/nullify/${id}`)
      if (res.code!=200)return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.getWarehouseallocationList()
    },
    //导出
    async DownloadWarehouseenter(){
      return new Promise((resolve, reject) => {
        // console.log(resolve)
        // console.log(reject)
        const {data:res} = this.$http.get('warehouseallocation/export', {
          responseType: "blob" // 1.首先设置responseType对象格式为 blob:
        })
            .then(
                res => {
                  //resolve(res)
                  let blob = new Blob([res.data], {
                    type: "application/vnd.ms-excel"
                  }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
                  let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
                  // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
                  let a = document.createElement("a");
                  var date = new Date();
                  a.href = url;
                  a.download = "库存调拨单"+date.getFullYear()+"-"+ (date.getMonth()+1) +"-"+date.getDate() +".xlsx";
                  a.click();
                  // 5.释放这个临时的对象url
                  window.URL.revokeObjectURL(url);
                },
                err => {
                  resolve(err.response);
                }
            )
            .catch(error => {
              reject(error);
            });
      });
    }


  }
}
</script>
<style>
.p_purchase_id{
  width: 100%;
}

.el-date-editor.el-input{
  width: 100%;

}
</style>

